export const LOCKED_PRODUCTS_DEFAULT_PAGE_SIZE = 50;
export const LOCKED_PRODUCTS_DEFAULT_SORT = "introducedAt";
